import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { LinkButton, TextWrapper } from '@clds/button';
import { useIntercomLauncher } from '@cld/intercom';
import { getAnalyticsProp } from '@cld/analytics';
import { messages } from '../../i18n';
import { FEEDBACK_SURVEY } from '../../ApplicationWrapper.const';
import styled from 'styled-components';
import { typography } from '@clds/typography';
import { FeedbackIcon } from './FeedbackIcon';

const StyledLinkButton = styled(LinkButton)`
  ${TextWrapper} {
    ${typography.xs.regular};
    padding-left: 1px;
  }
  padding-left: 10px;
`;

export const FeedbackButton = () => {
  const analyticsProps = getAnalyticsProp('open Intercom feedback');
  const { formatMessage } = useIntl();
  const intercomFromContext = useIntercomLauncher();
  const onclickCallback = useCallback(() => {
    if (window.Intercom) {
      window.Intercom('startSurvey', FEEDBACK_SURVEY);
    } else {
      intercomFromContext.startSurvey(FEEDBACK_SURVEY);
    }
  }, [intercomFromContext]);

  return (
    <>
      <StyledLinkButton size="sm" leftSlot={<FeedbackIcon />} onClick={onclickCallback} {...analyticsProps}>
        {formatMessage(messages.feedbackButton)}
      </StyledLinkButton>
    </>
  );
};
